module.exports = __webpack_public_path__ + "static/media/vi.f95cf953.svg";